/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Customschoolname2Inputs */

const en__field_customschoolname2 = /** @type {(inputs: _Field_Customschoolname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`School Name (if not listed)`)
};

const de__field_customschoolname2 = /** @type {(inputs: _Field_Customschoolname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der Schule (falls nicht aufgeführt)`)
};

/**
* | output |
* | --- |
* | "School Name (if not listed)" |
*
* @param {_Field_Customschoolname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_customschoolname2 = /** @type {((inputs?: _Field_Customschoolname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Customschoolname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_customschoolname2(inputs)
	return de__field_customschoolname2(inputs)
});
export { _field_customschoolname2 as "_field_customSchoolName" }